export const imgSplash = require("../assets/logo.png");
export const imgloader = require("../assets/loader.png");
export const splashImage = require("../assets/backimage_splash.png")
export const splashLogo = require("../assets/imagebutton_logo.png")